import type {
  ApplicationVersionResourceReadV2Api,
  BffApplicationVersionResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type {
  MappedBffApplicationVersionResourceReadV2Api,
  MappedUpdateApplicationVersionResourceV2Api,
} from '../../models/applicationVersion.model';

export function mapBffApplicationVersionById(
  data: BffApplicationVersionResourceReadV2Api,
): MappedBffApplicationVersionResourceReadV2Api {
  return {
    applicationDependencyVersionIds: data.applicationDependencyVersionIds,
    applicationId: data.applicationId,
    artifacts: data.artifacts,
    compatibleOsVersionIds: data.compatibleOsVersionIds,
    creationDate: data.creationDate,
    id: data.id,
    longDescription: data.longDescription,
    publisherId: data.publisherId,
    shortDescription: data.shortDescription,
    size: data.size,
    status: data?.status,
    systemPackageDependencyVersionIds: data.systemPackageDependencyVersionIds,
    templates: data.templates,
    versionNumber: data.versionNumber,
    applicationDependencyVersions: data.applicationDependencyVersions,
    compatibleOsVersions: data.compatibleOsVersions,
    systemPackageDependencyVersions: data.systemPackageDependencyVersions,
    downloadRules: data.downloadPolicies,
  };
}

export function mapApplicationVersionById(
  response: ApplicationVersionResourceReadV2Api,
): MappedUpdateApplicationVersionResourceV2Api {
  return {
    applicationDependencyVersionIds: response.applicationDependencyVersionIds,
    artifacts: response.artifacts,
    compatibleOsVersionIds: response.compatibleOsVersionIds,
    creationDate: response.creationDate,
    id: response.id,
    longDescription: response.longDescription,
    publisherId: response.publisherId,
    shortDescription: response.shortDescription,
    size: response.size,
    status: response.status,
    applicationId: response.applicationId,
    templates: response.templates,
    versionNumber: response.versionNumber,
    downloadRules: response.downloadPolicies,
  };
}
